export default {
  english: {
    deleteMyAccount: 'Delete my account',
    yes: 'Permanently delete my account',
    no: 'Cancel',
    areYouSure: 'Are you really sure you want to delete your account? All your\nprofile informations, as well as your favorite marked contents will be deleted\nfrom i24NEWS. Posted comments will remain visible on the website but will be\nanonymized. You can contact us if you want your comments to be permanently\nremoved.',
    error: 'An error occured while deleting your account. Please retry.',
  },
  french: {
    deleteMyAccount: 'Supprimer mon compte',
    yes: 'Supprimer définitivement mon compte',
    no: 'Annuler',
    areYouSure: 'Êtes vous sûr de vouloir supprimer votre compte ? Toutes les\ninformations de votre compte, ainsi que vos contenus marqués comme favoris\nseront supprimés d\'i24NEWS. Les commentaires postés resteront visibles sur le\nsite mais seront anonymisés. Vous pouvez nous contacter si vous souhaitez que\nvos commentaires soient définitivement supprimés.',
    error: 'Une erreur est survenue pendant la suppression. Veuillez recommencer.',
  },
  arabic: {
    deleteMyAccount: 'احذف حسابي',
    yes: 'بالتأكيد احذف حسابي',
    no: 'إلغاء',
    areYouSure: 'هل أنت متأكد حقًا من أنك تريد حذف حسابك؟ سيتم حذف جميع معلومات ملفك الشخصي ، وكذلك محتوياتك المفضلة المعلمة من i24NEWS. ستبقى التعليقات المنشورة مرئية على الموقع ولكن سيتم الكشف عن هويتها. يمكنك الاتصال بنا إذا كنت تريد بالتأكيد إزالة تعليقاتك.',
    error: 'حدث خطأ أثناء الحذف. الرجاء اعادة المحاولة.',
  },
  hebrew: {
    deleteMyAccount: 'מחק את החשבון שלי',
    yes: 'מחק את החשבון לצמיתות',
    no: 'בטל',
    areYouSure: 'האם אתה בטוח שברצונך למחוק את החשבון? כל המידע בפרופיל, כמו גם התוכן שסימנת יימחקו מ-i24NEWS. תגובות שפורסמו מהפרופיל יישארו באתר, אך באופן אנונימי. צור עימנו קשר אם ברצונך למחוק את התגובות לצמיתות.',
    error: 'שגיאה ארעה במהלך מחיקת חשבונך. אנא נסה שוב',
  },
  persian: {
    deleteMyAccount: 'اکانت من رو پاک کن',
    yes: 'اکانت من را برای همیشه حذف کنید',
    no: 'لغو کنید',
    areYouSure: 'آیا واقعاً مطمئن هستید که می خواهید حساب خود را حذف کنید؟ همه شما\nاطلاعات نمایه و همچنین محتویات علامت گذاری شده مورد علاقه شما حذف خواهند شد\nاز i24NEWS. نظرات ارسال شده در وب سایت قابل مشاهده خواهند بود اما قابل مشاهده خواهند بود\nناشناس اگر می خواهید نظرات شما دائمی باشد، می توانید با ما تماس بگیرید\nحذف شده است.',
    error: 'هنگام حذف حساب شما خطایی روی داد. لطفا دوباره امتحان کنید.',
  },
}
